import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';
import shouldForwardProp from '@styled-system/should-forward-prop';

export interface BaseDivProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    GridProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {
  overflowScrolling?: string;
  WebkitOverflowScrolling?: string;
}

type NonCollidingDivProps = WithoutCollidingProps<BaseDivProps, 'div'>;
type NonCollidingDivKeys = keyof NonCollidingDivProps;

export const Div = styled('div', {
  shouldForwardProp: (prop): prop is NonCollidingDivKeys =>
    shouldForwardProp(prop as NonCollidingDivKeys),
})<BaseDivProps>(
  defineWithTheme('divs'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    grid,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export type DivProps = React.ComponentPropsWithoutRef<typeof Div>;
